module.exports = __webpack_public_path__ + "static/media/hw_te_19.f92ac4de.flv";